import { SupplierAllocationSearchCriteria } from './supplier-allocation-search-criteria';

export class ResourceAllocationSearchCriteria extends SupplierAllocationSearchCriteria {
    preferredRoutes: string[];
    preferredTransferModes: string[];

    rejectedResourceIdList: number[];
    isPrivateBooking: boolean;
}
